<div class="title">
    <mwp-text-translate text="Signature" jsonKey="signature" />
</div>
<div class="content">
    <div class="message-card blue-fill mb-4">
        <mwp-text-translate text="Please sign your name using your mouse, tablet stylus, or other input device in the signature block below and click the Submit button to complete this enrollment session and post your elections for processing." jsonKey="signatureInstructions" />
    </div>
    <div class="mb-3">
        <mwp-signature (emitCancel)="cancelSignature()" (emitComplete)="completeSignature($event)"/>
    </div>
    <div class="mb-3">
        <mwp-text-translate text="By signing above, you authorize your elections for the benefits and/or benefit requests presented on the preceding Summary page. Further, you certify that all eligibility and/or underwriting questions answered by you during this enrollment session are true and accurate, you authorize your employer to take any payroll deductions required for the options selected, and you agree with all carrier/vendor disclosures, terms, and/or conditions for coverage and/or underwriting presented." jsonKey="signatureAcknowledgement" />
    </div>
</div>